import { LocaleFunc, register } from 'timeago.js';
import de from 'timeago.js/lib/lang/de';

const customGermanLocale: LocaleFunc = (number: number, index: number) => {
  if (index <= 1) return ['gerade eben', 'vor einer Weile'];
  return de(number, index);
};

register('de-custom', customGermanLocale);
